var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisationsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3359 10.663H12.6693V11.9963H11.3359V10.663ZM12.6693 7.99634H11.3359V9.32967H12.6693V7.99634Z",
    fill: "#9BA4AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66797 5.32975H15.3346V14.6631H0.667969V2.66309H8.66797V5.32975ZM5.33464 3.99642H7.33464V5.32975H5.33464V3.99642ZM7.33464 13.3298V11.9964H5.33464V13.3298H7.33464ZM7.33464 10.6631V9.32975H5.33464V10.6631H7.33464ZM7.33464 7.99642V6.66309H5.33464V7.99642H7.33464ZM14.0013 13.3298V6.66309H8.66797V7.99642H10.0013V9.32975H8.66797V10.6631H10.0013V11.9964H8.66797V13.3298H14.0013ZM2.0013 13.3298V11.9964H4.0013V13.3298H2.0013ZM2.0013 10.6631H4.0013V9.32975H2.0013V10.6631ZM4.0013 7.99642V6.66309H2.0013V7.99642H4.0013ZM2.0013 5.32975H4.0013V3.99642H2.0013V5.32975Z",
    fill: "#9BA4AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationsIcon);
export default __webpack_public_path__ + "static/media/organisations-icon.9be15a0542a9b1b5dfdc3b579bf780b7.svg";
export { ForwardRef as ReactComponent };